import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { paymentTermsColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import type { ApiPaymentTerms } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { PaymentTermsRepository } from '@Repositories/Stammdaten';

export function FrameListPaymentTerms() {
    const hasPermission = useHasPermission();

    const module = useListApi(PaymentTermsRepository, STAMMDATEN_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiPaymentTerms>
            layoutSettingsContext={EnumFrontendLayoutSetting.PaymentTermsTableLayout}
            name="PaymentTermsList"
            columns={paymentTermsColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.StammdatenPaymentTermsCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
